import BootstrapField from '../utility/BootstrapField';
// import moment from 'moment';
// import CloneDeep from 'lodash.clonedeep';
// import DeepDiff from 'deep-diff';
import IsEqual from 'lodash.isequal';


// As private as it gets.
let originalOrganizationData = null;

export default class Organization {

	static get getYesNoOptions() {
		return [
			{
				text: 'Yes',
				value: 1
			},
			{
				text: 'No',
				value: 0
			}
		];
	}


	static get getOrganizationTypeId() {
		return [
			{
				value: null,
				text: 'Select a Type',
				disabled: true,
			},
			{
				value: 'agency',
				text: 'Construction Agency'
			},
			{
				value: 'city',
				text: 'City of Winnipeg Department / Branch / Division'
			},
			{
				value: 'province',
				text: 'Province of Manitoba Department / Branch / Division'
			},
			{
				value: 'utility',
				text: 'Utility'
			},
		/*{value:'other', text:'Other'},*/
		];
	}


	static get getIsApprovedOptions() {
		return [
			{
				value: 1,
				text: "Approved"
			},
			{
				value: 0,
				text: "Not Approved"
			},
		];
	}

	static get getIsActiveOptions() {
		return [
			{
				value: 1,
				text: "Active"
			},
			{
				value: 0,
				text: "Inactive"
			},
		];
	}

	static get getSortOptions() {
		return [
			{
				text: 'Name A->Z',
				value: 'name asc',
			},
			{
				text: 'Name Z->A',
				value: 'name desc',
			},
			{
				text: 'Created Date - Newest Entry First',
				value: 'createdDate desc',
			},
			{
				text: 'Created Date - Oldest Entry First',
				value: 'createdDate asc',
			}
		]
	}

	static getIsActiveText(id) {
		if (id) {
			return this.searchById(id, this.getIsActiveOptions).text;
		}
		return null;
	}

	static getIsApprovedText(id) {
		if (id) {
			return this.searchById(id, this.getIsApprovedOptions).text;
		}
		return null;
	}

	static searchById(nameKey, iArray) {
		for (let i = 0; i < iArray.length; i++) {
			if (iArray[i].value === nameKey) {
				return iArray[i]
			}
		}
	}


	constructor(data) {
		if (!data) {
			data = {};
		}
		Object.assign(this, {
			id: data.id || null,
			accessCode: data.accessCode || null,
			parentId: new BootstrapField({
				value: data.parentId || null,
				required: true,
				fnRawValue: function() {
					if (this.value == null) {
						return null;
					}
					if (this.value.id != null) {
						return this.value.id;
					} else {
						return this.value;
					}
				}
			}),


			organizationTypeId: new BootstrapField({
				value: data.organizationTypeId || null,
			}),
			name: new BootstrapField({
				value: data.name || null,
				required: true,
			}),

			domain: new BootstrapField({
				value: data.domain || null,
			}),

			isApproved: new BootstrapField({
				value: typeof data.isApproved === 'number' ? data.isApproved : null,
			}),

			isActive: new BootstrapField({
				value: typeof data.isActive === 'number' ? data.isActive : 1,
			}),
			comments: new BootstrapField({
				value: data.comments || null,
			}),
			createdDate: new BootstrapField({
				value: data.createdDate || null,
			}),
			createdUserId: new BootstrapField({
				value: data.createdUserId || null,
			}),
			namePath: new BootstrapField({
				value: data.namePath || null,
			}),
			idPath: new BootstrapField({
				value: data.idPath || null,
			}),
			typePath: new BootstrapField({
				value: data.typePath || null,
			}),
		});

		// Keep a record of the old data. (used for the hasChanges() method)
		// originalOrganizationData = CloneDeep(this);
		originalOrganizationData = this.getRawValue();
	}

	validate() {
		let flag = true;
		let errors = [];
		for (let field in this) {
			if (this[field] instanceof BootstrapField) {
				let result = this[field].validate();
				if (result === false) {
					errors.push(field);
					flag = false;
				}
			}
		}
		if (this.parentId.value == this.id) {
			this.parentId.status = false;
			this.parentId.invalidMessage = "Organization cannot be its own parent.";
			errors.push(this.parentId);
			flag = false;
		}
		return flag;
	}

	getRawValue() {
		return getRawValue(this);

		function getRawValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getRawValue();
			} else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							if (typeof obj[key][arrKey] != "function") {
								value[key].push(getRawValue(obj[key][arrKey]));
							}
						}
					} else {
						if (key == "mapPolyline") {
							value[key] = null;
						} else {
							if (typeof value[key] != "function") {
								value[key] = getRawValue(obj[key]);
							}
						}
					}
				}
			} else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}

	getValue() {
		return getValue(this);

		function getValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getValue();
			} else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							value[key].push(getValue(obj[key][arrKey]));
						}
					} else {
						value[key] = getValue(obj[key]);
					}
				}
			} else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}


	hasChanges() {

		// var differences = DeepDiff.diff(originalOrganizationData.getRawValue(),  this.getRawValue());

		return !IsEqual(originalOrganizationData, this.getRawValue());
		// return false;
	}
	revertChanges() {
		// this.constructor(originalOrganizationData);
		originalOrganizationData = this.getRawValue();
	}
	saveChanges() {
		// originalOrganizationData = CloneDeep(this);
		originalOrganizationData = this.getRawValue();
	}

	getRawValue() {
		return getRawValue(this);

		function getRawValue(obj) {
			let value = {};
			if (obj instanceof BootstrapField) {
				value = obj.getRawValue();
			} else if (obj instanceof Object && Object.keys(obj).length > 0) {
				for (let key in obj) {
					if (obj[key] instanceof Array) {
						value[key] = [];
						for (let arrKey in obj[key]) {
							if (typeof obj[key][arrKey] != "function") {
								value[key].push(getRawValue(obj[key][arrKey]));
							}
						}
					} else {
						value[key] = getRawValue(obj[key]);
					}
				}
			} else if (obj instanceof Array && obj.length > 0) {
				// This shouldnt ever run, as an array is also an object.
			}
			// Default, just return the value;
			else {
				value = obj;
			}
			return value;
		}
	}

}